import React from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "./AuthContext"

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth() // Get the authentication state

  if (!isAuthenticated) {
    return <Navigate to="/adminlogin" replace /> // Redirect to login if not authenticated
  }

  return children // If authenticated, render the children components
}

export default ProtectedRoute
